import { makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";

const useStyle = makeStyles((theme) => ({
  omrFileInputContainer: {
    border: '1px solid #8080808f',
    borderRadius: '4px',
    position: 'relative',
    cursor:'pointer !important'
  },
  omrFileInput: {
    opacity: 0,
    zIndex: 99,
    cursor:'pointer !important'
  },
  fileName: {
    position: 'absolute',
    top: '8px',
    left: '10px',
    zIndex: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: "90% !important",
    cursor:'pointer'
  },
  uploadedfilesBox:{
 border: '1px solid #8080808f',
    borderRadius: '0 0 4px',
    height:'auto',
    maxHeight:'100px',
    overflow:'scroll',
    scrollbarWidth:'none',
    padding:'12px'
  }
}))
const OmrFileInput = ({ setSelectedFiles, selectedFiles }) => {
  const classes = useStyle();

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    // Filter for image, PDF, and ZIP files
    const allowedFiles = files.filter((file) => {
      const fileName = file.name.toLowerCase();
      return (
        file.type.startsWith("image/") ||
        file.type === "application/pdf" ||
        file.type === "application/zip" ||
        file.type === "application/x-zip-compressed" ||
        fileName.endsWith(".zip")
      );
    });
    setSelectedFiles(allowedFiles);
       // reset input so the same file can be chosen again
    // setSelectedFiles((prev) => [...prev, ...allowedFiles]); // append new files
  };

  return (
    <>
      <div className={`${classes.omrFileInputContainer} `}>
        <TextField
          type="file"
          variant="outlined"
          className={`${classes.omrFileInput}`}
          onChange={handleFileChange}
          inputProps={{
            multiple: true,
            accept: "image/*,.zip,application/zip,application/x-zip-compressed",
          }}
        />
        <div className={`${classes.fileName}`}>Choose Image / ZIP</div>
        {selectedFiles.length > 0 && (
          <div className={`${classes.uploadedfilesBox}`}>
            {selectedFiles.map((file) => file.name).join(", ")}
          </div>
        )}
      </div>
    </>
  );
}
export default OmrFileInput;